<template>
  <section class="page-container">
    <div class="filter-card">
      <div class="filter-top">
        <span>Search</span>
        <v-input
          v-model="search"
          placeholder="Code, Customer Name, Moblie No."
          @keyEnter="filterData" />
      </div>
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="changeDate" />
          </div>
        </div>
      </div>
    </div>

    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'">
        <el-table-column
          align="center"
          label="Code"
          prop="order_sn">
        </el-table-column>
        <el-table-column
          label="Title"
          prop="isrd_title_language">
        </el-table-column>
        <el-table-column
          label="Customer Name"
          prop="isrd_nm">
        </el-table-column>
        <el-table-column
          label="Mobile No."
          prop="mobile_no">
        </el-table-column>
        <el-table-column
          label="Created On">
          <template #default="{row}">
            <p>{{row.created_date}}</p>
            <p>{{row.created_time}}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getKFLMList, KFLMListExport} from '@/api/micropolicy'
import {downloadFile} from '@/utils/download'
export default {
  name: 'PurchaseList',
  data () {
    return {
      search: null,
      date: [],
      tableData:[],
      pageConfig:{
        total: 0,
        currentPage: 1
      }
    }
  },
  created(){
    this.network().getList()
  },
  methods: {
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },

    filterData(){
      this.network().getList()
    },

    handlerDown() {
      this.network().KFLMListExport()
    },

    network(){
      return {
        getList: async () => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
          }
          const { data } = await getKFLMList(params)
          this.pageConfig.currentPage = data.current_page
          this.pageConfig.total = data.total
          this.tableData = data.data
        },

        KFLMListExport: async() => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
          }
          const res = await KFLMListExport(params)
          downloadFile(res)
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.page-container{
  .filter-card {
    margin-bottom: 30px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;
    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;
      & > span {
        display: inline-block;
        padding-right: 10px;
      }
    }
    .filter-main {
      display: flex;
      padding: 0 15px;
      .filter-left {
        padding: 15px 0;
        width: 290px;
        min-width: 290px;
      }
    }
  }
}
::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      //display: flex;
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
      //height: 40px;
     .cell{
       //min-height: 40px;
       line-height: 18px;
       position: relative;
       height: inherit;
       //margin-left: 10px;
       //margin-right: 10px;
       padding: 0;
       //padding: 5px 10px;
       //position: absolute;
       //top: 10px;
     }
    }
  }
  .table-pointer{
    cursor: pointer;
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;
  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
  }
  .button-border{
    display: inline-block;
    padding: 0px 10px;
    height: auto;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #E1E4E8;
    color: #24292E;
    background: white;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 18px;

  }
}
</style>
